import BSHtmlBaseBillableStrategy from './BSHtmlBaseBillableStrategy'

export default function BSHtmlBillableTimeAndAmountStrategy() {}

BSHtmlBillableTimeAndAmountStrategy.prototype = new BSHtmlBaseBillableStrategy()

BSHtmlBillableTimeAndAmountStrategy.prototype.addFirstHeaderRowCells = function(row, levelsNumber) {
    this.addCell(row, this.message("report.billing_summary.overall_amount.html", [SystemSettings.currencySign]),
        "billableAmount", 1, levelsNumber)
}

BSHtmlBillableTimeAndAmountStrategy.prototype.addColumnValueCells = function(row) {
    this.addMoneyValueCell(row, "darkMoneyValueCell")
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBillableTimeAndAmountStrategy.js